var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadGenerationExcellence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1716 12.6562V23.3438C21.1716 25.0912 19.755 26.5078 18.0076 26.5078C16.2601 26.5078 14.8435 25.0912 14.8435 23.3438V12.6562H6.40601V23.3438C6.40601 29.7511 11.6002 34.9453 18.0076 34.9453C24.4149 34.9453 29.6091 29.7511 29.6091 23.3438V12.6562H21.1716Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6091 18.9844H21.1716",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8435 18.9844H6.40601",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.4375C20.0387 8.4375 21.6914 6.7848 21.6914 4.74609C21.6914 2.70739 20.0387 1.05469 18 1.05469C15.9613 1.05469 14.3086 2.70739 14.3086 4.74609C14.3086 6.7848 15.9613 8.4375 18 8.4375Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6016 8.4375C31.6403 8.4375 33.293 6.7848 33.293 4.74609C33.293 2.70739 31.6403 1.05469 29.6016 1.05469C27.5629 1.05469 25.9102 2.70739 25.9102 4.74609C25.9102 6.7848 27.5629 8.4375 29.6016 8.4375Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39844 8.4375C8.43714 8.4375 10.0898 6.7848 10.0898 4.74609C10.0898 2.70739 8.43714 1.05469 6.39844 1.05469C4.35973 1.05469 2.70703 2.70739 2.70703 4.74609C2.70703 6.7848 4.35973 8.4375 6.39844 8.4375Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadGenerationExcellence);
export default __webpack_public_path__ + "static/media/lead-generation-excellence.fc41d9d1fcd0cc067e85e063d396937c.svg";
export { ForwardRef as ReactComponent };